// Week planner presets and display helpers. The categories themselves (labels, colours, default
// titles) are data — planner_categories, editable from the week view (see
// services/planner/categories.js) — and arrive with every week response.

// Used when a block points at a category the page doesn't know (should not happen).
export const FALLBACK_CATEGORY = { key: 'other', label: 'Other', bg: '#e5e7eb', fg: '#374151', default_title: '' };

// Special fields of the built-in categories, shown in the category manager so nobody wonders
// why those can only be hidden.
export const BUILTIN_FEATURES = {
  arrival: 'Everybody present or optional medical treatment',
  routine: 'Treatment time, everybody time and meal',
  meeting_video: 'Topics (players / staff only)',
  gym: "Players see their own gym assignment from the Week Schedule",
  individual_meeting: 'Optional per-player meeting slots',
  rotation: 'Two stations for Group 1 / Group 2, swapping halfway',
};

export const categoryMap = list => Object.fromEntries((list || []).map(c => [c.key, c]));

// Arrival purpose: everybody present, or an optional early arrival for medical treatment
// (players who want treatment can come from this time — nobody is assigned to it).
export const ARRIVAL_PURPOSES = [
  { id: 'everybody', label: 'Everybody present',            title: 'Arrival' },
  { id: 'treatment', label: 'Medical treatment (optional)',  title: 'Arrival · medical treatment' },
];

// The trainer's two standard routines (weeks 38-40). Times stay editable per block.
export const ROUTINE_PRESETS = [
  {
    id: 'morning', label: 'Morning routine', start_time: '08:15', end_time: '10:00',
    routine: { treatment_from: '08:30', everybody_at: '09:00', meal: { label: 'Breakfast', start: '09:00', end: '10:00' } },
  },
  {
    id: 'afternoon', label: 'Afternoon routine', start_time: '11:45', end_time: '13:30',
    routine: { treatment_from: '12:00', everybody_at: '12:30', meal: { label: 'Lunch', start: '12:30', end: '13:30' } },
  },
];

// Audience chips (player-specific tokens come from the player picker). See
// services/planner/audience.js for what each token means.
export const AUDIENCE_CHIPS = [
  { token: 'all',        label: 'Everyone' },
  { token: 'gk',         label: 'Goalkeepers' },
  { token: 'played',     label: 'Played (60+ min)' },
  { token: 'not_played', label: "Didn't play" },
  { token: 'rot:1',      label: 'Group 1' },
  { token: 'rot:2',      label: 'Group 2' },
  { token: 'staff',      label: 'Staff only' },
];

const CHIP_SHORT = { gk: 'GK', played: 'Played', not_played: 'Not played', 'rot:1': 'G1', 'rot:2': 'G2' };

// Short audience hint shown on a block in the grid ('' for everyone).
export function audienceHint(tokens) {
  if (!tokens || tokens.includes('all')) return '';
  const players = tokens.filter(t => t.startsWith('player:')).length;
  const parts = tokens.filter(t => CHIP_SHORT[t]).map(t => CHIP_SHORT[t]);
  if (players) parts.push(`${players} player${players === 1 ? '' : 's'}`);
  return parts.join(' · ');
}

// "Treatment 08:30 · All 09:00 · Breakfast"
export function routineSummary(r) {
  if (!r) return '';
  return [
    r.treatment_from ? `Treatment ${r.treatment_from}` : null,
    r.everybody_at ? `All ${r.everybody_at}` : null,
    r.meal ? r.meal.label : null,
  ].filter(Boolean).join(' · ');
}
